<template>
  <v-dialog
      v-model="dialogVisible"
      max-width="600px"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs"/>
    </template>
    <v-form v-model="valid" @submit.prevent="save">
      <v-card>
        <v-card-title>
          <span v-if="data.id" class="text-h5">Upravit uživatele</span>
          <span v-else class="text-h5">Přidat uživatele</span>
        </v-card-title>

        <v-card-text>
          <v-text-field
              v-model="data.username"
              label="Přihlašovací jméno"
              :rules="[rules.required]"
          />
          <v-text-field
              v-model="data.password"
              label="Nové heslo"
              hint="Vyplňte jen pokud se má změnit"
              type="password"
              autocomplete="new-password"
          />
          <v-radio-group v-model="data.admin">
            <v-radio value="0" label="Přístup jen pro čtení"/>
            <v-radio value="1" label="Přístup pro čtení i zápis"/>
          </v-radio-group>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="close"
          >
            Zrušit
          </v-btn>
          <v-btn
              type="submit"
              color="blue darken-1"
              text
              :disabled="!valid"
          >
            Uložit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import {api, defaultApiErrorHandler} from "@/main";

export default {
  name: "UserForm",
  props: {
    id: String,
  },

  watch: {
    id: function (id) {
      if (!id || id === '0') {
        this.data = { ...this.newData };
        return;
      }
      api
          .get('user.php', { params: { id: id } })
          .then(response => {
            console.log('loaded user data', response);
            this.data = response.data;
            this.dialogVisible = true;
          })
          .catch(defaultApiErrorHandler);
    },
    dialogVisible: function (isVisible) {
      if (!isVisible) {
        this.$emit('closed');
      }
    },
  },

  data: () => ({
    dialogVisible: false,
    valid: false,
    data: {},
    newData: {
      password: '',
      admin: '0',
    },
    rules: {
      required: value => !!value || 'Musí být vyplněno.',
    },
  }),

  created() {
    this.data = { ...this.newData };
  },

  methods: {
    close () {
      this.dialogVisible = false;
      this.data = { ...this.newData };
    },

    save () {
      console.log('saving', this.data);
      api
          .post('user.php', this.data)
          .then(response => {
            console.log('saved', response);
            this.$emit('updated');
            this.close()
          })
          .catch(defaultApiErrorHandler);
    },
  },
}
</script>
